import { startTempChatWithContact } from '../../tempChat/tempChatService.ts'
import { TEMP_CHAT_DURATIONS } from '../../tempChat/tempChatUtils.ts'
import { contactDisplayName, findContact } from '../../storage/pairingStore.ts'
import { t, tf } from '../../i18n/index.ts'
import { applyAppLayout } from '../layout.ts'
import { appendBlocks, escapeHtml } from '../dom.ts'
import { getParam, navigate } from '../router.ts'
import type { RenderStaleCheck } from '../renderGuard.ts'

export async function renderTempChatDurationScreen(
  root: HTMLElement,
  isStale: RenderStaleCheck = () => false,
): Promise<void> {
  const contactId = getParam('contactId')
  const contact = await findContact(contactId)
  if (isStale()) return
  if (!contact) {
    navigate('home')
    return
  }

  applyAppLayout('page')
  root.innerHTML = ''
  appendBlocks(
    root,
    `
      <header class="topbar premium-topbar">
        <button type="button" class="icon-btn" id="btn-back">←</button>
        <h2 class="topbar-title">${escapeHtml(t('temp_duration_title'))}</h2>
      </header>
      <section class="card temp-chat-intro">
        <p class="temp-chat-icon center icon-btn-clock" aria-hidden="true"></p>
        <h2 class="card-title center">${escapeHtml(tf('temp_duration_with', { name: contactDisplayName(contact) }))}</h2>
        <p class="status muted center small">${escapeHtml(t('temp_duration_hint'))}</p>
      </section>
      <section class="card">
        <div id="duration-list" class="duration-list"></div>
        <p id="temp-start-status" class="status muted"></p>
      </section>
    `,
  )

  if (isStale()) return

  const list = root.querySelector('#duration-list') as HTMLElement
  const statusEl = root.querySelector('#temp-start-status') as HTMLElement
  let starting = false

  root.querySelector('#btn-back')!.addEventListener('click', () => navigate('home'))

  for (const { label, ms } of TEMP_CHAT_DURATIONS) {
    const btn = document.createElement('button')
    btn.type = 'button'
    btn.className = 'duration-option'
    btn.textContent = label
    btn.addEventListener('click', () => {
      if (starting) return
      void (async () => {
        starting = true
        for (const b of list.querySelectorAll('button')) {
          ;(b as HTMLButtonElement).disabled = true
        }
        statusEl.textContent = t('temp_sending_invite')
        statusEl.className = 'status muted'
        const result = await startTempChatWithContact(contactId, ms)
        if (isStale()) return
        if (!result.ok || !result.chatKey) {
          statusEl.textContent = result.error ?? t('common_error')
          statusEl.className = 'status err'
          starting = false
          for (const b of list.querySelectorAll('button')) {
            ;(b as HTMLButtonElement).disabled = false
          }
          return
        }
        navigate('home')
      })()
    })
    list.append(btn)
  }
}
